export const navigation = [
  {
    text: 'Inicio',
    path: '/home',
    icon: 'home'
  },
  {
    text: 'Perfil',
    path: '/profile',
    icon: 'user'
  },
  {
    text: 'Clientes',
    path: '/clientes',
    icon: 'user'
  },
  {
    text: 'Establecimientos',
    path: '/establecimientos',
    icon: 'home'
  },
  {
    text: 'Establecimientos Nuevos',
    path: '/establecimientosNuevos',
    icon: 'home'
  },
  {
    text: 'Activación',
    path: '/activacion',
    icon: 'home'
  },
  {
    text: 'Formularios',
    path: '/formularios',
    icon: 'textdocument'
  },
  {
    text: 'Regiones',
    path: '/regiones',
    icon: 'globe'
  },
  {
    text: 'Cuenta Bancaria',
    path: '/cuentaBancaria',
    icon: 'money'
  },
  {
    text: 'Pre-registro',
    path: '/PreRegister',
    icon: 'user'
  },
  {
    text: 'Reportes',
    path: '/reportes',
  },
  {
    text: 'Usuarios',
    path: '/User',
    icon: 'user'
  },
  {
    text: 'Preguntas Frecuentes',
    path: '/frequencyQuestions',
    icon: 'textdocument'
  },
  {
    text: 'Ordenes de Compra',
    path: '/ordenesCompra',
  },
  {
    text: 'Usuarios Coord.',
    path: '/UserCoord',
    icon: 'user'
  },
  {
    text: 'Descarga Reportes',
    path: '/reportspost', 
    icon: 'textdocument'
  },
  {
    text: 'Encuestas',
    path: '/encuestas',
    icon: 'textdocument'
  },
  {
    text: "Dotaciones",
    path: "/dotaciones",
    icon: "toolbox",
  },
  {
    text: "Crear Formularios",
    path: "/formManager",
    icon: "edit",
  },
];
